import { Flex } from "@chakra-ui/react";
import Many from './components/many';
import Baseline from './components/baseline';
import Features from './components/features';
import CallToAction from './components/callToAction';
import SEO from '../components/SEO';
import { useTranslation } from '../i18n/LanguageContext';

export default function HomePage() {
  const { t } = useTranslation();

  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Bibliona",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "description": t("jsonld.home.description"),
    "offers": [
      {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "name": t("pricing.basic"),
        "description": t("jsonld.home.basic.description"),
      },
      {
        "@type": "Offer",
        "price": "1.99",
        "priceCurrency": "USD",
        "name": t("pricing.pro"),
        "description": t("jsonld.home.pro.description"),
      },
    ],
  };

  return (
    <main>
      <SEO
        path="/home"
        description={t("seo.home.description")}
        jsonLd={homeJsonLd}
      />
      <Flex
        as="article"
        flexDirection={"column"}
        alignItems={"center"}
        p={"20px"}
        borderRadius={"20px"}
        paddingTop={"0"}
      >
        <Baseline />
        <Many />
        <Features />
        <CallToAction />
      </Flex>
    </main>
  );
}
